/**
 * @generated SignedSource<<ee936b5e64be008a8c391e137e3e25d9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EmployeeScheduleEditScheduleTypesScreenDeactivateMutation$variables = Record<PropertyKey, never>;
export type EmployeeScheduleEditScheduleTypesScreenDeactivateMutation$data = {
  readonly store: {
    readonly deactivateIntegrationEmployeeProvider: boolean | null;
  };
};
export type EmployeeScheduleEditScheduleTypesScreenDeactivateMutation = {
  response: EmployeeScheduleEditScheduleTypesScreenDeactivateMutation$data;
  variables: EmployeeScheduleEditScheduleTypesScreenDeactivateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deactivateIntegrationEmployeeProvider",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "EmployeeScheduleEditScheduleTypesScreenDeactivateMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "EmployeeScheduleEditScheduleTypesScreenDeactivateMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "76f6f351d2f1122680fd5ae3d40d305f",
    "id": null,
    "metadata": {},
    "name": "EmployeeScheduleEditScheduleTypesScreenDeactivateMutation",
    "operationKind": "mutation",
    "text": "mutation EmployeeScheduleEditScheduleTypesScreenDeactivateMutation {\n  store {\n    deactivateIntegrationEmployeeProvider\n  }\n}\n"
  }
};
})();

(node as any).hash = "6baaf12812bbaa1505d027e562429b5c";

export default node;
